module.exports = require("./kk-KZ");